const removeFromReducer = (state, action) => state.filter((element) => element !== action.element);
export default removeFromReducer;
